import React from 'react';
import PropTypes from 'prop-types';

const Remove = ({ className, color, onClick }) => (
  <svg className={className} onClick={onClick} viewBox="-1 -1 16 16">
    <path
      fill={color}
      fillRule="evenodd"
      d="M7 5.586L4.738 3.324c-.315-.315-.822-.31-1.136.003l-.186.186c-.315.315-.317.824-.004 1.137l2.262 2.262-2.35 2.35c-.315.315-.31.822.003 1.136l.186.186c.315.315.824.317 1.137.004L7 8.238l2.35 2.35c.315.315.822.31 1.137-.004l.186-.186c.314-.314.316-.823.003-1.136l-2.35-2.35 2.262-2.262c.315-.315.31-.822-.004-1.137l-.186-.186c-.314-.314-.823-.316-1.136-.003L7 5.586z"
    />
  </svg>
);

Remove.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
};

Remove.defaultProps = {
  color: '#797C7F',
};

export default Remove;
